var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#002240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27934 7.32562L9.32562 3.27934C9.69807 2.90689 10.3019 2.90689 10.6744 3.27934C11.0468 3.65179 11.0468 4.25565 10.6744 4.6281L7.30248 8L10.6744 11.3719C11.0468 11.7444 11.0468 12.3482 10.6744 12.7207C10.3019 13.0931 9.69807 13.0931 9.32562 12.7207L5.28163 8.67667C5.28086 8.67591 5.2801 8.67515 5.27933 8.67438C4.90688 8.30193 4.90689 7.69807 5.27934 7.32562Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVLeft);
export default __webpack_public_path__ + "static/media/v-left.37ee137299161f41c99613e2f08ede21.svg";
export { ForwardRef as ReactComponent };